import { Card, CardContent } from "../ui/card";
import { Skeleton } from "../ui/skeleton";

export function FloorSummarySkeleton() {
  return (
    <Card className="border-border/50 bg-card">
      <CardContent className="p-4">
        <Skeleton className="h-4 w-32 mb-4" />

        <div className="flex flex-col gap-3">
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-full" />
        </div>
      </CardContent>
    </Card>
  )
}